import React from 'react';
import {TraceResultObj} from "./App";
import {Paper} from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    Label,
    ResponsiveContainer
} from "recharts";

// const results = "traceroute to 13.32.181.128 (13.32.181.128), 15 hops max, 60 byte packets\n 1  185.165.52.1 (185.165.52.1)  0.159 ms\n 2  ix-xe-11-1-0-3-0.tcore1.aeq-ashburn.as6453.net (66.198.155.130)  0.348 ms\n 3  63.243.137.133 (63.243.137.133)  0.452 ms\n 4  216.6.87.251 (216.6.87.251)  0.440 ms\n 5  *\n 6  *\n 7  *\n 8  150.222.236.77 (150.222.236.77)  0.731 ms\n 9  *\n10  *\n11  *\n12  *\n13  *\n14  *\n15  *\n"
const results = "traceroute to 93.184.216.34 (93.184.216.34), 15 hops max, 60 byte packets\n 1  185.165.54.145 (185.165.54.145)  0.235 ms\n 2  adm-b2-link.ip.twelve99.net (80.239.161.129)  0.541 ms\n 3  adm-bb3-link.ip.twelve99.net (62.115.141.66)  92.105 ms\n 4  prs-bb1-link.ip.twelve99.net (62.115.134.97)  91.762 ms\n 5  ash-bb2-link.ip.twelve99.net (62.115.112.242)  94.437 ms\n 6  ash-b2-link.ip.twelve99.net (62.115.123.123)  91.132 ms\n 7  verizon-ic-315152-ash-b1.ip.twelve99-cust.net (213.248.83.119)  95.408 ms\n 8  ae-65.core1.dcb.edgecastcdn.net (152.195.64.129)  91.441 ms\n 9  *\n10  *\n11  *\n12  *\n13  *\n14  *\n15  *\n"

interface ResponseObj {
    agent: {
        agentId: string;
        siteId: number;
        status: string;
    },
    result: string;
}


function listOfIps() {
    return results.split('\n').map(x => {
        if (x.split('  ').length === 3) {
            return x.split(' ')[4].replace('(', '').replace(')', '')
        } else if (x.split('  ').length === 2) {
            return x.split('  ')[1]
        }
        return ''
    })
}

function listOfSpeeds() {
    return results.split('\n').map(x => {
        if (x.split('  ').length === 3) {
            return parseFloat(x.split(' ')[6])
        } else if (x.split('  ').length === 2) {
            return 0
        }
        return ''
    })
}



interface Props {
    result: Array<TraceResultObj>
    traceRunning: boolean
}
function Chart(props: Props) {
    const {result, traceRunning} = props;

    const ipArr = result.map(resultObj => {
        if (resultObj.ip === 'n/a') {
            return '*'
        }
        return resultObj.ip
    })

    const speedArr = result.map(resultObj => {
        if (resultObj.rtnn === 'n/a') {
            return 0
        }
        return parseFloat(resultObj.rtnn)
    })

    const data = {
        labels: ipArr,
        datasets: [
            {
                label: 'Speed in ms',
                data: speedArr,
                fill: false,
                backgroundColor: '#424B93',
                borderColor: '#727EE8',
            },
        ],
    };

    const newData = ipArr.map((x, index) => {
        return {ip: ipArr[index], rttn: speedArr[index]}
    })

    const options = {
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ],
        },
    };

     if(result.length > 1 && traceRunning) {
        // Loading screen when a previous test what ran
        return (
            <>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '85%', height: '400px', position: 'absolute'}}>
                <CircularProgress size={60} color='secondary' />
                </div>
            <Paper style={{background: "rgba(255, 255, 255, .5)", paddingRight: '40px', filter: 'blur(2px)', }}>

                <ResponsiveContainer width='100%' height={400}>
                    <LineChart
                        data={newData}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="ip">
                            <Label value="Traceroute Hop" offset={0} position={"insideBottom"} />
                        </XAxis>
                        <YAxis dataKey="rttn" />
                        {/*<Tooltip />*/}
                        <Legend verticalAlign="top" />
                        <Line
                            animationDuration={0}
                            dataKey="rttn"
                            stroke="#8884d8"
                            strokeWidth={2}
                            activeDot={{ r: 2 }}
                            name="Speed(ms)"
                        />
                    </LineChart>
                </ResponsiveContainer>
            </Paper>
                </>
        )
    } else if(traceRunning) {
        // Loading screen when no previous test has been ran
        return (
            <>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '85%', height: '400px', position: 'absolute'}}>
                    <CircularProgress size={60} color='secondary' />
                </div>
            <Paper style={{background: "rgba(255, 255, 255, .5)", paddingRight: '40px', filter: 'blur(2px)', }}>
                <ResponsiveContainer width='100%' height={400}>
                    <LineChart
                        data={newData}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="ip">
                            <Label value="Traceroute Hop" offset={0} position={"insideBottom"} />
                        </XAxis>
                        <YAxis dataKey="rttn" />
                        {/*<Tooltip />*/}
                        <Legend verticalAlign="top" />
                        <Line
                            dataKey="rttn"
                            stroke="#8884d8"
                            strokeWidth={2}
                            activeDot={{ r: 2 }}
                            name="Speed(ms)"
                        />
                    </LineChart>
                </ResponsiveContainer>
            </Paper>
                </>
        )
    } else {
        // Default Chart
        return <Paper style={{width: '100%', paddingRight: '40px'}}>
                <ResponsiveContainer width='100%' height={400}>
                    <LineChart
                        data={newData}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="ip">
                            <Label value="Traceroute Hop" offset={0} position={"insideBottom"} />
                        </XAxis>
                        <YAxis dataKey="rttn" />
                        <Tooltip />
                        <Legend verticalAlign="top" />
                        <Line
                            dataKey="rttn"
                            stroke="#8884d8"
                            strokeWidth={2}
                            activeDot={{ r: 2 }}
                            name="Speed(ms)"
                        />
                    </LineChart>
                </ResponsiveContainer>

        </Paper>
    }
};

export default React.memo(Chart);